import { FB_Template, ItemAccount, Month } from '@algomusinc/domain';
import { EventEmitter } from '@angular/core';
import { addCommas } from './addCommas';
import { calculateAttachRateMeasureGDP } from './calculateAttachRateMeasureGDP';
import { calculateAttachRateMeasureRDP } from './calculateAttachRateMeasureRDP';
import {
  mapCummulatedObject,
  mapCummulatedObjectAg,
} from './mapCummulatedObject';

export const collapseMonth = (
  month: Month | any,
  measureKeys: Array<string>,
  parentKey: string,
  forecastKeys: Array<string>,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  calculateMeasures: EventEmitter<any>,
  calcPctMeasures: Array<string>,
  fbTemplateId: number
) => {
  measureKeys.forEach((key) => {
    if (key.indexOf('Comment') < 0) {
      month.measures[key] = 0;
    } else {
      month.measures[key] = '';
    }
  });
  month.weekList.forEach((week: any) => {
    measureKeys.forEach((key) => {
      mapCummulatedObject(
        month,
        key,
        week,
        parentKey,
        spreadEqualMeasures,
        lowHeirarichyMeasures
      );
    });
  });
  measureKeys.forEach((key) => {
    if (key.indexOf('Pct') > 0 && !calcPctMeasures.includes(key)) {
      month['measures'][key] = month.weekList.every(
        (row: any) => row['measures'][key] == month['measures'][key]
      )
        ? month['measures'][key]
        : 'Multiple %';
    } else if (calcPctMeasures.includes(key)) {
      if (fbTemplateId === FB_Template.Global_Planning) {
        calculateAttachRateMeasureGDP(month);
      } else if (fbTemplateId === FB_Template.Regional_Planning) {
        calculateAttachRateMeasureRDP(month);
      }
    }
    if (key.indexOf('Comment') > 0) {
      month['measures'][key] = month.weekList.every(
        (row: any) => row['measures'][key] == month['measures'][key]
      )
        ? month['measures'][key]
        : 'Multiple Comments';
    }
    if (key.indexOf('Comment') < 0 && !spreadEqualMeasures.includes(key)) {
      month['measures'][key] = month['measures'][key]

        .toString()
        .replace(/,/g, '');

      addCommas(month.measures, key);
      month.weekList.forEach((week: any) => {
        addCommas(week.measures, key);
      });
    }
  });
  return month;
};
export const collapseMonthAg = (
  month: Month | any,
  measureKeys: Array<string>,
  parentKey: string,
  forecastKeys: Array<string>,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  calculateMeasures: EventEmitter<any>,
  calcPctMeasures: Array<string>,
  fbTemplateId: any,
  fbForecastMIVResponseModelKey: any,
  transformMeasureKeys: Array<string>,
  multipleAggregatedMeasures: Array<string>,
  masterMeasureList: Array<any>
): any => {
  const object = {
    ...month[parentKey],
  };
  if ([FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner].includes(fbTemplateId)) {
    month = collapseMivMonthAg(
      month,
      measureKeys,
      parentKey,
      forecastKeys,
      spreadEqualMeasures,
      lowHeirarichyMeasures,
      calculateMeasures,
      calcPctMeasures,
      fbTemplateId,
      fbForecastMIVResponseModelKey,
      transformMeasureKeys,
      multipleAggregatedMeasures
    )
  } else {
    let avgCount = 0;
    measureKeys.forEach((key: any) => {
      if (key.indexOf('Comment') < 0) {
        month[parentKey][key] = 0;
      } else {
        month[parentKey][key] = '';
      }
    });
    month.weekList.forEach((week: any) => {
      measureKeys.forEach((key: any) => {
        // calculateForecastMeasures(key,week)
        mapCummulatedObjectAg(
          month,
          key,
          week,
          parentKey,
          spreadEqualMeasures,
          lowHeirarichyMeasures
        );
      });
      avgCount = avgCount + 1;
    });
    measureKeys.forEach(key => {
      if(transformMeasureKeys.includes(key) && key.indexOf('Pct')<0){
        let selectedMeasure = masterMeasureList.find((e:any)=>e.code == key);
        if(selectedMeasure.measureTypeId == 3){
          month[parentKey][key] = Number(month[parentKey][key]/avgCount);
        }
      }
    });
    measureKeys.forEach((key: any) => {
      if (month[parentKey][key] == undefined) return;

      if (key.indexOf('Pct') > 0 && (!calcPctMeasures.includes(key) || fbTemplateId == 5)) {
        let transformMeasureCondition = false;
        if (fbTemplateId == 5) {
          if (key.indexOf('--') > 0) {
            let measureKey = key.split('--');
            if (measureKey && measureKey.length > 0) {
              transformMeasureCondition = transformMeasureKeys?.includes(measureKey[0]);
            }
          } else {
            transformMeasureCondition = transformMeasureKeys?.includes(key)
          }
        } else {
          transformMeasureCondition = transformMeasureKeys?.includes(key)
        }
        if (transformMeasureCondition) {
          month[parentKey][key] = 0;
          let avgCount = 0;
          month.weekList.forEach((row: any) => {
            month[parentKey][key] = +row[parentKey][key] + month[parentKey][key];
            avgCount = avgCount + 1;
            // month[parentKey][key] = Number(((+row[parentKey][key] + month[parentKey][key])/(index+1)).toFixed(2));
          });
          month[parentKey][key] = Number((month[parentKey][key] / (avgCount)).toFixed(2));
        } else {
          month[parentKey][key] = month.weekList.every((row: any) => row[parentKey][key] == month[parentKey][key]) ? month[parentKey][key] : 'Multiple %';
        }
      } else if (calcPctMeasures.includes(key) && fbTemplateId != 5) {
        if (fbTemplateId === FB_Template.Global_Planning) {
          calculateAttachRateMeasureGDP(month);
          calculateAttachRateMeasureRDP(month);
        } else if (fbTemplateId === FB_Template.Regional_Planning) {
          calculateAttachRateMeasureRDP(month);
          calculateAttachRateMeasureGDP(month);
        }
      }
      if (key.indexOf('Comment') > 0) {
        month[parentKey][key] = month.weekList.every(
          (row: any) => row[parentKey][key] == month[parentKey][key]
        )
          ? month[parentKey][key]
          : ['PromoIndicatorComments', 'LYPromoIndicatorComments', 'PromoDetailsComments'].includes(key) ? 'See Details' : 'Multiple Comments';
      }
      if (key.indexOf('Comment') < 0 && !spreadEqualMeasures.includes(key)) {
        month[parentKey][key] = month[parentKey][key];
      }
    });
  }
  return month;
};
function collapseMivMonthAg(
  month: Month,
  measureKeys: Array<string>,
  parentKey: string,
  forecastKeys: Array<string>,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  calculateMeasures: EventEmitter<any>,
  calcPctMeasures: Array<string>,
  fbTemplateId: number,
  fbForecastMIVResponseModelKey: any,
  transformMeasureKeys: Array<string>,
  multipleAggregatedMeasures: Array<string>,
) {
  month[fbForecastMIVResponseModelKey] = JSON.parse(JSON.stringify([...month.weekList[0][fbForecastMIVResponseModelKey]]));
  measureKeys.forEach((key: any) => {
    // @ts-ignore
    month[fbForecastMIVResponseModelKey].forEach((monthFbForecastMIVResponseModel: any) => {
      if (key.indexOf('Comment') < 0) {
        monthFbForecastMIVResponseModel[parentKey][key] = 0;
      } else {
        monthFbForecastMIVResponseModel[parentKey][key] = '';
      }
    });
  });
  let avgCount = 0;
  month.weekList.forEach((week: any) => {
    for (let index = 0; index < week[fbForecastMIVResponseModelKey].length; index++) {
      measureKeys.forEach((key: any) => {
        // @ts-ignore
        if (month[fbForecastMIVResponseModelKey] && month[fbForecastMIVResponseModelKey].length > 0) {
          mapCummulatedObjectAg(
            month[fbForecastMIVResponseModelKey][index],
            key,
            week[fbForecastMIVResponseModelKey][index],
            parentKey,
            spreadEqualMeasures,
            lowHeirarichyMeasures,
            multipleAggregatedMeasures
          );
        }
      });
    }
    avgCount = avgCount + 1;
  });
  measureKeys.forEach(key => {
    if(transformMeasureKeys.includes(key) && key.indexOf('Pct') < 0){
      for (let index = 0; index < 20; index++) {
        month[fbForecastMIVResponseModelKey][index][parentKey][key] = Number(month[fbForecastMIVResponseModelKey][index][parentKey][key]/avgCount);
      }
    }
  });
  // @ts-ignore
  if (month[fbForecastMIVResponseModelKey] && month[fbForecastMIVResponseModelKey].length > 0) {
    for (let index = 0; index < month[fbForecastMIVResponseModelKey]?.length; index++) {
      measureKeys.forEach((key: any) => {
        // @ts-ignore
        if (month[fbForecastMIVResponseModelKey][index][parentKey][key] == undefined) return;

        if (key.indexOf('Pct') > 0 && !calcPctMeasures.includes(key)) {
          if (transformMeasureKeys && transformMeasureKeys.length > 0 && transformMeasureKeys.includes(key)) {
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = 0;
            let avgCount = 0;
            month.weekList.forEach((row: any) => {
              // month[fbForecastMIVResponseModelKey][index][parentKey][key] = Number(((+row[fbForecastMIVResponseModelKey][index][parentKey][key] + month[fbForecastMIVResponseModelKey][index][parentKey][key])/(index+1)).toFixed(2));
              month[fbForecastMIVResponseModelKey][index][parentKey][key] = +row[fbForecastMIVResponseModelKey][index][parentKey][key] + month[fbForecastMIVResponseModelKey][index][parentKey][key];
              avgCount = avgCount + 1;
            });
            // month[parentKey][key] = Number((month[parentKey][key]/(avgCount)).toFixed(2));
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = Number((month[fbForecastMIVResponseModelKey][index][parentKey][key] / avgCount).toFixed(2));
          } else {
            // @ts-ignore
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = month.weekList.every(
              (row: any) => {
                // @ts-ignore
                if (month[fbForecastMIVResponseModelKey][index][parentKey][key] == row[fbForecastMIVResponseModelKey][index][parentKey][key]) {
                  return true
                } else {
                  return false
                }
              }// @ts-ignore
            ) ? month[fbForecastMIVResponseModelKey][index][parentKey][key] : 'Multiple %';
          }
        }
        if (key.indexOf('Comment') > 0) {
          // @ts-ignore
          month[fbForecastMIVResponseModelKey][index][parentKey][key] = month.weekList.every(
            (row: any) => {
              // @ts-ignore
              if (month[fbForecastMIVResponseModelKey][index][parentKey][key] == row[fbForecastMIVResponseModelKey][index][parentKey][key]) {
                return true
              } else {
                return false
              }
            } // @ts-ignore
          ) ? month[fbForecastMIVResponseModelKey][index][parentKey][key] : 'Multiple Comments';
        }
        if (key.indexOf('Comment') < 0 && !spreadEqualMeasures.includes(key)) {
          // @ts-ignore
          if (multipleAggregatedMeasures.includes(key)) {
            const isSameValue =   month.weekList.every((row: any) => Number(row[fbForecastMIVResponseModelKey][index][parentKey][key]) == Number(month[fbForecastMIVResponseModelKey][index][parentKey][key]));
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = isSameValue ? month[fbForecastMIVResponseModelKey][index][parentKey][key] : 'Multiple';
          } else {
            month[fbForecastMIVResponseModelKey][index][parentKey][key] = month[fbForecastMIVResponseModelKey][index][parentKey][key];
          }

        }
      });
    }
  }
  return month;
}
